import { render, staticRenderFns } from "./CreateSetting.vue?vue&type=template&id=2f4d3df8&"
import script from "./CreateSetting.vue?vue&type=script&lang=ts&"
export * from "./CreateSetting.vue?vue&type=script&lang=ts&"
import style0 from "./CreateSetting.vue?vue&type=style&index=0&id=2f4d3df8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports